import _regenerator from "C:/Users/lptni/\u5F00\u53D1/dev/project/unbox-server/vue-admin/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "C:/Users/lptni/\u5F00\u53D1/dev/project/unbox-server/vue-admin/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import api from '@/api';
import util from '@/libs/util.js';
export default {
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  name: 'ByMemberResourceImport',
  data: function data() {
    return {
      pushMessagePeopleGrous: [],
      dialogImageUrl: '',
      fileList: [],
      uploadUrl: process.env.VUE_APP_API,
      uploadHeaders: {
        Authorization: util.cookies.get('token')
      },
      title: '',
      pushMessagePushTypeEnums: [],
      form: {
        messageId: null,
        title: '',
        message: '',
        images: '',
        peopleGroup: '',
        pushType: '',
        peopleNum: null,
        readNum: null,
        displayType: null,
        pushTime: null,
        memberIds: [],
        messageType: null
      },
      rules: {
        messageId: [{
          required: true,
          message: '请输入消息id',
          trigger: 'blur'
        }],
        title: [{
          required: true,
          message: '请输入标题',
          trigger: 'blur'
        }],
        message: [{
          required: true,
          message: '请输入消息',
          trigger: 'blur'
        }],
        images: [{
          required: true,
          message: '请输入图片',
          trigger: 'blur'
        }],
        peopleGroup: [{
          required: true,
          message: '请输入推送群体',
          trigger: 'blur'
        }],
        pushType: [{
          required: true,
          message: '请输入推送类型',
          trigger: 'blur'
        }],
        peopleNum: [{
          required: true,
          message: '请输入推送人数',
          trigger: 'blur'
        }],
        readNum: [{
          required: true,
          message: '请输入阅读人数',
          trigger: 'blur'
        }],
        displayType: [{
          required: true,
          message: '请输入显示类型;0 后台显示，1个人记录显示',
          trigger: 'blur'
        }],
        pushTime: [{
          required: true,
          message: '请输入推送时间',
          trigger: 'blur'
        }]
      }
    };
  },
  methods: {
    submitUpload: function submitUpload() {
      this.$refs.upload.submit();
    },
    handleAvatarSuccess: function handleAvatarSuccess(res, file) {
      this.fileList.push(file);
      this.$emit('initTableData');
      this.handleClose();
    },
    beforeAvatarUpload: function beforeAvatarUpload(file) {
      var isLt2M = file.size / 1024 / 1024 < 10;
      if (!isLt2M) {
        this.$message.error('上传文件不能超过 10MB!');
      }
      return isLt2M;
    },
    handleRemove: function handleRemove(file, fileList) {
      this.fileList = fileList;
    },
    getPushMessagePeopleGroupEnums: function getPushMessagePeopleGroupEnums() {
      var _this = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var res;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _context.n = 1;
              return api.GET_ENUMERATION_LIST({
                name: 'push_message_people_group'
              });
            case 1:
              res = _context.v;
              _this.pushMessagePeopleGrous = res.body;
            case 2:
              return _context.a(2);
          }
        }, _callee);
      }))();
    },
    getPushMessagePushTypeEnums: function getPushMessagePushTypeEnums() {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var res;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              _context2.n = 1;
              return api.GET_ENUMERATION_LIST({
                name: 'push_message_type'
              });
            case 1:
              res = _context2.v;
              _this2.pushMessagePushTypeEnums = res.body;
            case 2:
              return _context2.a(2);
          }
        }, _callee2);
      }))();
    },
    initEunmData: function initEunmData() {
      this.getEnumList('key');
    },
    getEnumList: function getEnumList(name) {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var par, res;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              par = {
                name: name
              };
              _context3.n = 1;
              return api.GET_ENUMERATION_LIST(par);
            case 1:
              res = _context3.v;
              _this3.enumList = res.body;
            case 2:
              return _context3.a(2);
          }
        }, _callee3);
      }))();
    },
    setTitle: function setTitle(title) {
      this.title = title;
    },
    initMemberData: function initMemberData(par) {
      this.initData();
      this.form.memberIds = par;
      this.form.displayType = 1;
    },
    initData: function initData(data) {
      if (this.$refs.form !== undefined) {
        this.$refs.form.resetFields();
      }
      this.fileList = [];
    },
    setData: function setData(data) {
      if (this.$refs.form !== undefined) {
        this.$refs.form.resetFields();
      }
      this.fileList = [];
    },
    updateApi: function updateApi() {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              _context4.n = 1;
              return api.UPDATE_PUSHMESSAGE(_this4.form);
            case 1:
              _this4.$emit('initTableData');
              _this4.$message.success('操作成功');
              _this4.handleClose();
            case 2:
              return _context4.a(2);
          }
        }, _callee4);
      }))();
    },
    saveApi: function saveApi() {
      var _this5 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.n) {
            case 0:
              _context5.n = 1;
              return api.SAVE_PUSHMESSAGE(_this5.form);
            case 1:
              _this5.$emit('initTableData');
              _this5.$message.success('操作成功');
              _this5.handleClose();
            case 2:
              return _context5.a(2);
          }
        }, _callee5);
      }))();
    },
    save: function save() {
      var _this6 = this;
      if (this.fileList.length > 0) {
        var files = [];
        this.fileList.forEach(function (file) {
          files.push(file.response.body);
        });
        this.form.images = JSON.stringify(files);
      }
      this.$refs.form.validate(function (valid) {
        if (valid) {
          if (_this6.form.messageId != null) {
            _this6.$confirm('此操作将永久修改该数据, 是否继续?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(function () {
              _this6.updateApi();
            }).catch(function () {
              _this6.$message({
                type: 'info',
                message: '已取消修改'
              });
            });
          } else {
            _this6.saveApi();
          }
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    handleClose: function handleClose(done) {
      this.$emit('close');
    }
  },
  created: function created() {}
};